export const gaDimensions = {
  csStoreName: 82
};
